import { cx } from 'cva'
import type { FC, PropsWithChildren } from 'react'

export type GridProps = {
	className?: string
}

export const Grid: FC<PropsWithChildren<GridProps>> = ({ children, className }) => {
	return (
		<div
			className={cx(
				'grid grid-cols-4 gap-x-gutter tablet-p:grid-cols-8 tablet-l:grid-cols-12',
				className,
			)}
		>
			{children}
		</div>
	)
}
